import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "45%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "8px",
  outline: "none",
};

const ErrorModal = ({ openModal, message, handleClick, buttonText }) => {
  return (
    <Modal open={openModal}>
      <Box sx={style}>
        <Typography variant="h5" component="h2" color="#eb4034">
          ¡Error!
        </Typography>
        <Box
          sx={{
            overflowY: "auto",
            fontFamily: "Arial, sans-serif",
            color: "#333",
            textAlign: "justify",
          }}
        >
          <Typography sx={{ mt: 2 }}>{message}</Typography>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <Button variant="contained" onClick={handleClick}>
            {buttonText}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ErrorModal;
